import React from 'react'
import { useSelector } from 'react-redux'
import { useGetLocationModulesQuery } from 'Services/institution'

const Header = () => {
  const { locId, instId, instName } = useSelector(
    (state: any) => state.location
  )

  const { data: modulesData, isSuccess: modulesSuccess } =
    useGetLocationModulesQuery({ instId, locId }, { skip: !instId || !locId })

  const iMapEnabled = modulesSuccess
    ? modulesData?.resources.some(
        (module: any) => module.moduleid === 'fullmap'
      )
    : false

  const mapDirectionsEnabled = modulesSuccess
    ? modulesData?.resources.some(
        (module: any) => module.moduleid === 'directions'
      )
    : false

  if (!modulesSuccess) return null

  return (
    <div data-testid='header'>
      <h1 tabIndex={0}>
        {instName}
      </h1>
      <p>
        This is the accessible version of the virtual tour designed specifically
        for users needing extra accessibility features.
        <br />
        Feel free to{' '}
        <a href={`${process.env.REACT_APP_BASE_URL}/tour/${instId}/${locId}`}>
          check out the original experience here.
        </a>
      </p>
      {iMapEnabled && mapDirectionsEnabled && (
        <p>
          Click on the{' '}
          <a
            href={`${process.env.REACT_APP_BASE_URL}/tour/map/${instId}/${locId}`}
          >
            interactive map
          </a>{' '}
          to explore points of interest on campus and custom trails.
        </p>
      )}
    </div>
  )
}

export default Header
